import {
  Box,
  Button,
  Card,
  Checkbox,
  Grid,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { ErrorMessage, Formik } from "formik";
import React from "react";
import { useStyles } from "../styles";
import Pen from "../../../../assets/images/CourseManagement/pen.svg";
import Close from "../../../../assets/images/CourseManagement/close.svg";
import CustomExpandMore from "../../../../common/CustomExpandMore";
import { useNavigate } from "react-router-dom";
import weekDay from "../../../../Utils/weekdays";
import useSemester from "../../../../Hooks/semester";
import useMyClass from "../../../../Hooks/myClass";
import useCourse from "../../../../Hooks/course";
import * as Yup from "yup";
import { useState } from "react";
import { useCallback } from "react";
import CustomPagination from "../../../../common/Pagination";
import usePagination from "../../../../common/usePagination";

import logout from "../../../../assets/images/Sidebar/logout.svg";
import { updateClassScroll } from "../../../../Utils/scrollToView";
import DropZoneUpload from "../../../../common/DropZoneUpload";
import useAuthStore from "../../../../Hooks/auth";
const columns = [
  {
    id: "name",
    sortby: true,
    label: "S No",
    align: "center",
  },
  {
    id: "fromDate",
    sortby: true,
    label: "From Date",
    align: "center",
  },
  {
    id: "toDate",
    label: "To Date",
    align: "center",
    sortby: true,
  },
  {
    id: "courseName",
    label: "Course",
    align: "center",
  },
  {
    id: "year",
    label: "Year",
    align: "center",
  },
  {
    id: "delete",
    label: "Action",
    align: "center",
  },
];

const myClassSchema = Yup.object().shape({
  courseName: Yup.string().required("* Please select course"),
  year: Yup.string().required("* Please select semester year"),
  // startTime: Yup.string().required("* Please select start time"),
  // endTime: Yup.string().required("* Please select end time"),
  toDate: Yup.date().required("* Please enter period order").nullable(),
  // section: Yup.string().required("* Please enter section"),
  // weekDay: Yup.string().required("* Please enter week day"),
  fromDate: Yup.date().required("* Please enter fromDate").nullable(),
});
const UpdateClasses = () => {
  const classes = useStyles();

  const { getSemesterAction, semesterData } = useSemester();
  const {
    getClassesAction,
    classData,
    getActiveClassAction,
    activeClass,
    updateClassesAction,
    deleteClassesAction,
  } = useMyClass();
  const { userId } = useAuthStore();

  const { getDepartmentAction, departmentData, courseData } = useCourse();
  const [file, setFile] = useState(null);
  const [mediaURL, setMediaURL] = useState("");

  const [page, setPage] = useState(1);
  const [PerPage, setPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const [open, setOpen] = useState(false);
  const { institutionId } = useAuthStore();

  const handlePage = (e) => {
    setPerPage(e.target.value);
  };
  const navigate = useNavigate();
  const count =
    classData &&
    Math.ceil(classData?.totalNoOfRecords?.totalNoOfRecords / PerPage);
  const _DATA = usePagination(classData?.classes, PerPage);
  const flatListClassesData = React.useMemo(() => {
    return _DATA.currentData() || [];
  }, [classData, page]);
  const handleChange = useCallback(
    (e, p) => {
      setPage(p);
      setOffset(p * PerPage - PerPage);
      _DATA.jump(p);
    },
    [PerPage, page]
  );

  const handleChangeFile = (file) => {
    const _file = file[0];
    if (_file) {
      setFile(_file);
      let reader = new FileReader();
      reader.readAsDataURL(_file);
      reader.onload = () => {
        setMediaURL(reader.result.substr(reader.result.indexOf(",") + 1));
      };
    }
  };

  React.useEffect(() => {
    getSemesterAction({ limit: 50, offSet: 0 ,institutionId});
    getDepartmentAction({
      department: {
        institutionId,
      },
    });
    getClassesAction({ idFaculty: userId, limit: 10, offset: 0 });
    updateClassScroll("#updateClasses");
  }, []);

  const initValues = {
    courseName: activeClass?.courseName,
    year: activeClass?.year,
    // startTime: activeClass?.startTime,
    // endTime: activeClass?.endTime,
    toDate: activeClass?.toDate,
    // section: activeClass?.section,
    // weekDay: activeClass?.weekDay,
    fromDate: activeClass?.fromDate,
  };

  return (
    <Stack className={classes.myClass} id="updateClasses">
      <Grid container>
        <Grid item lg={9} sm={12}>
          <Stack>
            <Box sx={{ width: "100%" }}>
              <Paper
                sx={{
                  width: "100%",
                  borderRadius: "20px",
                  filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                  boxShadow: "none",
                }}
              >
                <Stack sx={{ p: 4 }}>
                  <Stack
                    sx={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Stack
                      sx={{
                        px: 2,
                        flexDirection: "row",
                        justifyContent: "right",
                      }}
                    >
                      <Typography
                        sx={{
                          pr: 2,
                          mb: 2,
                          // display: status ? "none" : "block",
                          transition: "width 0.3s",
                          fontFamily: "inter",
                        }}
                      >
                        Back
                      </Typography>
                      <Stack
                        sx={{ cursor: "pointer" }}
                        role={"button"}
                        onClick={() => navigate(-1)}
                      >
                        <img src={logout} alt="logout" />
                      </Stack>
                    </Stack>
                    <Button
                      type="submit"
                      sx={{
                        px: 1,
                        py: 1,
                        borderRadius: "50px",
                        marginBottom: "20px",
                      }}
                      form="updateClass"
                      className={classes.add_arrival}
                    >
                      Update Class
                    </Button>
                  </Stack>

                  <Formik
                    initialValues={initValues}
                    validationSchema={myClassSchema}
                    validateOnBlur={false}
                    validateOnChange={false}
                    onSubmit={(values) => {
                      updateClassesAction({
                        id: activeClass.id,
                        ...values,
                        // fileName: file?.name,
                        // contentType:
                        //   file?.name?.split(".")[
                        //     file?.name?.split(".").length - 1
                        //   ],
                        idFaculty: userId,
                        base64String: mediaURL,
                      });
                      navigate("/class");
                    }}
                  >
                    {(formik) => {
                      const {
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        values,
                      } = formik;
                      return (
                        <form id="updateClass" onSubmit={handleSubmit}>
                          <Grid
                            container
                            sx={{ py: 2 }}
                            className={classes.form_add_course}
                            spacing={4}
                          >
                            <Grid item md={6} sx={{ width: "100%" }}>
                              <Stack
                                sx={{
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Stack>
                                  <Typography className={classes.label}>
                                    From
                                  </Typography>
                                </Stack>
                                <Stack>
                                  <TextField
                                    id="fromDate"
                                    type="date"
                                    name="fromDate"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    onChange={handleChange}
                                    sx={{
                                      width: 240,
                                    }}
                                    className={
                                      errors.fromDate && touched.fromDate
                                        ? classes.inputError
                                        : classes.inputNoError
                                    }
                                    value={values.fromDate}
                                    placeholder="Enter fromDate"
                                  />
                                  <ErrorMessage
                                    name="fromDate"
                                    component="span"
                                    className={classes.error}
                                  />
                                </Stack>
                              </Stack>
                            </Grid>
                            <Grid item md={6} sx={{ width: "100%" }}>
                              <Stack
                                sx={{
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Stack>
                                  <Typography className={classes.label}>
                                    To
                                  </Typography>
                                </Stack>
                                <Stack>
                                  <TextField
                                    id="toDate"
                                    type="date"
                                    name="toDate"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    onChange={handleChange}
                                    sx={{
                                      width: 240,
                                    }}
                                    className={
                                      errors.toDate && touched.toDate
                                        ? classes.inputError
                                        : classes.inputNoError
                                    }
                                    value={values.toDate}
                                    placeholder="Enter To Date"
                                  />
                                  <ErrorMessage
                                    name="toDate"
                                    component="span"
                                    className={classes.error}
                                  />
                                </Stack>
                              </Stack>
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            sx={{ py: 1 }}
                            className={classes.form_add_course}
                            spacing={4}
                          >
                            <Grid item md={6} sx={{ width: "100%" }}>
                              <Stack
                                sx={{
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Stack>
                                  <Typography className={classes.label}>
                                    Course
                                  </Typography>
                                </Stack>
                                <Stack>
                                  <Select
                                    id="courseName"
                                    name="courseName"
                                    placeholder="Choose Course"
                                    onChange={handleChange}
                                    IconComponent={CustomExpandMore}
                                    className={
                                      errors.courseName && touched.courseName
                                        ? classes.inputError
                                        : classes.inputNoError
                                    }
                                    sx={{
                                      width: 240,
                                    }}
                                    value={values.courseName}
                                    displayEmpty
                                  >
                                    <MenuItem disabled value="">
                                      Select Course
                                    </MenuItem>
                                    {courseData &&
                                      courseData?.course?.map((_el, index) => (
                                        <MenuItem value={_el.id} key={index}>
                                          {_el.name}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                  <ErrorMessage
                                    name="courseName"
                                    component="span"
                                    className={classes.error}
                                  />
                                </Stack>
                              </Stack>
                            </Grid>
                            <Grid item md={6} sx={{ width: "100%" }}>
                              <Stack
                                sx={{
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Stack>
                                  <Typography className={classes.label}>
                                    Year
                                  </Typography>
                                </Stack>
                                <Stack>
                                  <Select
                                    id="year"
                                    name="year"
                                    className={
                                      errors.year && touched.year
                                        ? classes.inputError
                                        : classes.inputNoError
                                    }
                                    value={values.year}
                                    onChange={handleChange}
                                    placeholder="what's your favourite car?"
                                    IconComponent={CustomExpandMore}
                                    sx={{
                                      width: 240,
                                    }}
                                    displayEmpty
                                  >
                                    <MenuItem disabled value="">
                                      <span>Semester Year</span>
                                    </MenuItem>
                                    {semesterData?.map((_el) => (
                                      <MenuItem value={_el.id}>
                                        {_el.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  <ErrorMessage
                                    name="year"
                                    component="span"
                                    className={classes.error}
                                  />
                                </Stack>
                              </Stack>
                            </Grid>
                          </Grid>
                          <Stack
                            sx={{
                              marginTop: "20px",
                            }}
                          >
                            <DropZoneUpload
                              handleChangeFile={handleChangeFile}
                            />
                            <Stack sx={{ mb: 2 }}>
                              <em style={{ marginBottom: "10px" }}>
                                {file?.name}
                              </em>
                            </Stack>
                          </Stack>

                          {/* <Card
                            sx={{
                              height: "15rem",
                              marginTop: "2.5rem",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={2}
                              sx={{
                                border: "2px dotted #25d5a1",
                                width: "90%",
                                display: "flex",
                                justifyContent: "center",
                                margin: "20px 0 20px 0",
                                flexDirection: "column",
                                "& .MuiButton-root:hover": {
                                  background: `#feb62c !important`,
                                  color: `white !important`,
                                },
                              }}
                            >
                              <Button
                                component="label"
                                sx={{
                                  width: "40%",
                                  height: "30%",
                                  borderRadius: "22px",
                                  backgroundColor: "#feb62c",
                                  color: "white",
                                  textTransform: "capitalize !important",
                                  fontFamily: "inter !important",
                                }}
                              >
                                Upload
                                <input
                                  hidden
                                  accept="application/xls,application/xlsx"
                                  multiple
                                  type="file"
                                />
                              </Button>
                              <p
                                style={{
                                  fontSize: "11px",
                                  paddingTop: "13px",
                                  alignItems: "center",
                                }}
                              >
                                Files must be xlsx.xls and
                              </p>
                              <p
                                style={{ fontSize: "11px", paddingTop: "3px" }}
                              >
                                Max File size 10MB
                              </p>
                            </Stack>
                          </Card> */}
                          {/* <Stack
                            alignItems="center"
                            sx={{
                              marginTop: "40px",
                              "& .MuiButton-root:hover": {
                                background: `#25d5a1 !important`,
                                color: `white !important`,
                              },
                            }}
                          >
                            <Button
                              component="label"
                              sx={{
                                width: "30%",
                                height: "50px",
                                borderRadius: "22px",
                                backgroundColor: "#25d5a1",
                                color: "white",
                                textTransform: "capitalize !important",
                                fontFamily: "inter !important",
                              }}
                            >
                              Submit
                            </Button>
                          </Stack> */}
                          {/* <Grid
                            container
                            sx={{ pb: 2 }}
                            className={classes.form_add_course}
                            spacing={4}
                          >
                            <Grid item md={6} sx={{ width: "100%" }}>
                              <Stack
                                sx={{
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Typography className={classes.label}>
                                  Start Time
                                </Typography>
                                <Stack>
                                  <TextField
                                    id="startTime"
                                    type="time"
                                    name="startTime"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    onChange={handleChange}
                                    value={values.startTime}
                                    sx={{
                                      width: 240,
                                    }}
                                  />
                                  <ErrorMessage
                                    name="startTime"
                                    component="span"
                                    className={classes.error}
                                  />
                                </Stack>
                              </Stack>
                            </Grid>
                            <Grid item md={6} sx={{ width: "100%" }}>
                              <Stack
                                sx={{
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Stack>
                                  <Typography className={classes.label}>
                                    End Time
                                  </Typography>
                                </Stack>
                                <Stack>
                                  <TextField
                                    id="endTime"
                                    type="time"
                                    name="endTime"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    onChange={handleChange}
                                    value={values.endTime}
                                    sx={{
                                      width: 240,
                                    }}
                                  />
                                  <ErrorMessage
                                    name="endTime"
                                    component="span"
                                    className={classes.error}
                                  />
                                </Stack>
                              </Stack>
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            sx={{ pb: 2 }}
                            className={classes.form_add_course}
                            spacing={4}
                          >
                            <Grid item md={6} sx={{ width: "100%" }}>
                              <Stack
                                sx={{
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Stack>
                                  <Typography className={classes.label}>
                                    Week Day
                                  </Typography>
                                </Stack>
                                <Stack>
                                  <Select
                                    id="weekDay"
                                    name="weekDay"
                                    onChange={handleChange}
                                    IconComponent={CustomExpandMore}
                                    className={
                                      errors.weekDay && touched.weekDay
                                        ? classes.inputError
                                        : classes.inputNoError
                                    }
                                    sx={{
                                      width: 240,
                                    }}
                                    value={values.weekDay}
                                    displayEmpty
                                  >
                                    <MenuItem disabled value="">
                                      Select weekday
                                    </MenuItem>
                                    {weekDay?.map((_el, index) => (
                                      <MenuItem value={_el.name} key={index}>
                                        {_el.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  <ErrorMessage
                                    name="weekDay"
                                    component="span"
                                    className={classes.error}
                                  />
                                </Stack>
                              </Stack>
                            </Grid>
                            <Grid item md={6} sx={{ width: "100%" }}>
                              <Stack
                                sx={{
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Typography className={classes.label}>
                                  Section
                                </Typography>
                                <Stack>
                                  <TextField
                                    id="section"
                                    type="text"
                                    name="section"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    onChange={handleChange}
                                    value={values.section}
                                    sx={{
                                      width: 240,
                                    }}
                                  />
                                  <ErrorMessage
                                    name="section"
                                    component="span"
                                    className={classes.error}
                                  />
                                </Stack>
                              </Stack>
                            </Grid>
                          </Grid> */}
                        </form>
                      );
                    }}
                  </Formik>
                </Stack>
              </Paper>
            </Box>
          </Stack>

          <Stack sx={{ marginTop: "20px" }}>
            <Box sx={{ width: "100%" }}>
              <Paper
                sx={{
                  width: "100%",
                  borderRadius: "20px",
                  filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                  boxShadow: "none",
                }}
              >
                <Stack sx={{ p: 4 }}>
                  <TableContainer>
                    <Table
                      aria-label="sticky table"
                      className={classes.root}
                      style={{ padding: 0 }}
                    >
                      <TableHead>
                        <TableRow classes={{ root: classes.thead }}>
                          {columns?.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{
                                minWidth: column.minWidth,
                                paddingLeft: column.paddingLeft,
                              }}
                              classes={{ root: classes.columnData }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>

                      <TableBody classes={{ root: classes.tBody }}>
                        {flatListClassesData &&
                          flatListClassesData?.map((_el, index) => (
                            <TableRow role="checkbox" tabIndex={-1} key={index}>
                              {columns.map((column) => {
                                const value = _el[column.id];
                                //console.log("value", value);
                                return (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                  >
                                    {column.id === "name" ? (
                                      index + 1
                                    ) : column.id === "fromDate" ? (
                                      _el.fromDate || "-"
                                    ) : column.id === "toDate" ? (
                                      _el.toDate
                                    ) : column.id === "courseName" ? (
                                      _el.courseName
                                    ) : column.id === "year" ? (
                                      _el.year
                                    ) : column.id === "edit" ? (
                                      ""
                                    ) : (
                                      <>
                                        {" "}
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          <Stack
                                            sx={{
                                              alignItems: "center",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              navigate("/class/updateclass");
                                              getActiveClassAction(_el.id);
                                              updateClassScroll(
                                                "#updateClasses"
                                              );
                                            }}
                                          >
                                            <img src={Pen} alt="pen" />
                                          </Stack>
                                          <Stack
                                            sx={{
                                              alignItems: "center",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              deleteClassesAction({
                                                id: _el.id,
                                              })
                                            }
                                          >
                                            <img src={Close} alt="close" />
                                          </Stack>
                                        </div>
                                      </>
                                    )}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {classData?.length > 0 && (
                    <CustomPagination
                      count={count}
                      page={page}
                      onPageChange={handleChange}
                      handlePage={handlePage}
                      perPage={PerPage}
                    />
                  )}
                </Stack>
              </Paper>
            </Box>
          </Stack>
        </Grid>
        <Grid item lg={4} sm={12}></Grid>
      </Grid>
    </Stack>
  );
};

export default UpdateClasses;
